import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import { appearanceAt } from '../os/clock.ts'
import { WassupIcon } from '../os/icons/app-icons.tsx'
import styles from './notification-banners.module.css'
import type { Banner } from './use-notifications.ts'

/**
 * Wassup banners under the clock, iOS style: the app's icon, the sender, "now" and the message
 * on two lines. Each slides in, stays and fades out over `BANNER_MS`. In the OS's colours (its
 * tokens, `data-os`), light or dark by the game's clock, solid: nothing blurs the game.
 */
export function NotificationBanners({ banners }: { readonly banners: readonly Banner[] }) {
  const t = useT()
  const time = useView((view) => view.os.time)
  if (banners.length === 0) return null
  return (
    <ul
      class={styles.banners}
      data-os=""
      data-appearance={time === null ? 'light' : appearanceAt(time)}
      aria-live="polite"
    >
      {banners.map(({ message, chat }) => (
        <li key={message.id} class={styles.banner}>
          <WassupIcon class={styles.icon} />
          <span class={styles.body}>
            <span class={styles.top}>
              <span class={styles.sender}>{t(chat.name)}</span>
              <span class={styles.now}>{t(text('hud.notification.now'))}</span>
            </span>
            <span class={styles.message}>{t(message.text)}</span>
          </span>
        </li>
      ))}
    </ul>
  )
}
